// extracted by mini-css-extract-plugin
export default {"positiveFeedback":"Statistics_positiveFeedback__lXAf+"};